<template>
      <!-- right col START -->
    <div class="rightCol">

      <!-- row-5top start -->
      <div class="row-5top">
        <div @click="pagechange('report')"><img src="@/assets/images/notes.svg" alt="" /></div>
        <div @click="pagechange('statistics')"><img src="@/assets/images/keys.svg" alt="" /></div>
        <!--<div @click=""><img src="@/assets/images/detailed.svg" alt="" /></div>-->
        <div @click="tv()" @contextmenu.prevent="rightclick()"><img src="@/assets/images/tv.svg" alt="" /></div>
        <div @click="logout()"><img src="@/assets/images/power-button.svg" alt="" /></div>
      </div>
      <!-- row-5top stop -->


      <!-- scroll-block start -->
      <div class="scroll-block">

        <!-- eso-table start -->
        <div class="eso-table">
          <!-- eso-tr start -->
          <div class="eso-tr">
            <div class="eso-th">{{$t('event')}}</div>
            <div class="eso-th">{{$t('selection')}}</div>
            <div class="eso-th">{{$t('odds')}}</div>
            <div class="eso-th"></div>
          </div>
          <!-- eso-tr stop -->

          <!-- eso-tr start -->
          <div class="eso-tr" v-for="item in $store.state.Bets">
            <div class="eso-td"><p><b></b><span>{{getteams(item.HomeTeam)}}-{{getteams(item.AwayTeam)}}</span></p></div>
            <div class="eso-td">{{betName(item.Bet)}}</div>
            <div class="eso-td">{{item.Price}}</div>
            <div class="eso-td" @click="clearbet(item)"><img src="@/assets/images/cancel.svg" alt="" /></div>
          </div>
          <!-- eso-tr stop -->
          
        </div>
        <!-- eso-table stop -->


        <!-- Single Express start -->
        <div class="single-express" v-show="$store.state.Bets.length != 0">

          <!-- se-row start -->
          <div class="se-row">

            <div class="se-colleft">
              <div :class="statetype[0]" @click="expresschange('single')">{{$t('single')}}</div>
              <div class="odds">{{$t('odds')}}</div>
              <div class="minmax">
                <div class="min-col">
                  <div class="min">{{$t('min')}}</div>
                  <div class="number">{{minmax("min")}}</div>
                </div>
                <div class="max-col">
                  <div class="max">{{$t('max')}}</div>
                  <div class="number">{{minmax("max")}}</div>
                </div>
              </div>
            </div>

            <div class="se-colright">

              <div :class="statetype[1]" @click="expresschange('express')">{{$t('express')}}</div>
              <div class="group-stake">{{$t('groupstake')}}</div>

              <div class="se-input-box">

                <div class="se-input-block">
                  <div class="se-input"><input type="text" v-model="$store.state.total"/></div>
                  <div class="se-buttons">
                    <img src="@/assets/images/keys.png" alt="" @click.stop="calc()"/>
                  </div>
                </div>

                <!--<div class="se-input-block">
                  <div class="se-input"><input type="text" v-model="total"/></div>
                  <div class="se-buttons">
                    <img src="@/assets/images/keys.png" alt="" />
                  </div>
                </div>-->

              </div>

            </div>

          </div>
          <!-- se-row stop -->

          <!-- start -->
          <div class="tr-td5">
            <div @click="addsum(5)">5</div>
            <div @click="addsum(10)">10</div>
            <div @click="addsum(20)">20</div>
            <div @click="addsum(50)">50</div>
            <div @click="clear()">{{$t('clear')}}</div>
          </div>
          <div class="totalodds">
            <span>{{$t('total')}} {{$t('odds')}}:</span>
            <span>{{oddsSum()}}</span>
          </div>
          <!-- stop -->

        </div>
        <!-- Single Express stop -->

      </div>
      <!-- scroll-block stop -->


      <!-- Total stake: + Max total win: start -->
      <div class="tot">
        <div class="tot-row">
          <div>{{$t('total')}} {{$t('stake')}}:</div>
          <div v-if="$store.state.Bets.length != 0">$ {{$store.state.total}}</div>
        </div>
        <div class="tot-row">
          <div>{{$t('max')}} {{$t('total')}} {{$t('winss')}}:</div>
          <div v-if="$store.state.Bets.length != 0">$ {{($store.state.total * oddsSum()).toFixed(2)}}</div>
        </div>
      </div>
      <!-- Total stake: + Max total win: stop -->


      <!-- row-5bottom start -->
      <div class="row-5bottom">
        <div @click="ClearAll()"><img src="@/assets/images/recycle-bin-interface-symbol.svg" alt="" /></div>
        <div @click.stop="payment('Return')"><img src="@/assets/images/invoice.svg" alt="" /></div>
        <div @click.stop="payment('Pay')"><img src="@/assets/images/search.svg" alt="" /></div>
        <div @click="repeat()"><img src="@/assets/images/receipt.svg" alt="" /></div>
        <div @click.stop="placeBet()"><img src="@/assets/images/printer.svg" alt="" /></div>
      </div>
      <!-- row-5bottom stop -->

      <div class="logo2"><img src="@/assets/images/logo-2.svg" alt="" /></div>     

      <modal :active="show_payment" 
        v-on:modalClosed="show_payment=false" 
        class="payment-modal"><paymentcards :state="state" /></modal>

        <modal :active="show_error" 
        v-on:modalClosed="show_error=false" 
        class="payment-modal"><errpop :state="state" :msg="msgs"/></modal>

      <modal :active="show_calc" v-on:modalClosed="show_calc=false" class="ticket-modal"><calculator/></modal>
        
    </div>
    <!-- right col STOP -->
</template>

<script>
import Cookies from 'js-cookie'
import i18n from '@/i18n'
import Vue from 'vue'
import ticket from '@/views/Ticket.vue'
import paymentcards from '@/views/PaymentCards.vue'
import calculator from '@/views/Calculator.vue'
import modal from '@/components/Modal.vue'
import errpop from '@/views/TextPOPup.vue'

export default {
  name: 'Calc',
  data: ()=>{
    return {
      express: false,
      total: 0,
      show_error: false,
      show_payment: false,
      show_calc: false,
      state: "",
      msgs: "",
      statetype: ['single', 'express']
    }
  },
  components: {
    paymentcards, modal, calculator, errpop
  },
  props: {
    msg: String
  },
  computed: {

  },
  methods: {
    pagechange(page){
      this.$store.state.total = 0;
      this.$store.state.Bets = [];
      this.$router.push({name: page})
    },
    expresschange(type){
      if(this.$store.state.Bets.length < 2) {
        this.statetype = ['single', 'express'];
        this.express = false;
        return 
      }
      if(type == 'single'){
       this.statetype = ['single', 'express'];
       this.express = false;
     }else{
        this.statetype = ['express', 'single'];
        this.express = true;
     }
    },
    betName(name){
      if(name == "GG") return this.$t('gg')
      if(name == "NG") return this.$t('ng')
      if(name.includes('Over')){
        if(name.includes('Home')) return this.$t('home')+this.$t('over')+name.slice(8)
        if(name.includes('Away')) return this.$t('away')+this.$t('over')+name.slice(8)
        if(name[0] == "1" || name[0] == "X" || name[0] == "2") return name[0]+this.$t('over')+name.slice(5)
        return this.$t('over')+name.slice(4)
      } 
      if(name.includes('Under')){
        if(name.includes('Home')) return this.$t('home')+this.$t('under')+name.slice(9)
        if(name.includes('Away')) return this.$t('away')+this.$t('under')+name.slice(9)
        if(name[0] == "1" || name[0] == "X" || name[0] == "2") return name[0]+this.$t('under')+name.slice(6)
        return this.$t('under')+name.slice(5)
      }
      if(name.includes('Goals')) return this.$t('goals')+name.slice(5)
      return name
    },
    calc(){
      this.show_calc = true
    },
    getteams(team){
      let result = this.$store.state.teams.filter(item => item.id == team);
      return result[0].Abriviation
    },
    addsum(num){
      this.$store.state.total = parseFloat(this.$store.state.total) + num;
      //this.total += num;
    },
    clear(){
      this.$store.state.total = 0;
    },
    clearbet(bet){
      let i = this.$store.state.Bets.findIndex((element) => element == bet);
      return this.$store.state.Bets.splice(i, 1);
    },
    ClearAll(){
      this.$store.state.total = 0;
      this.$store.state.Bets = [];
      this.shown = false
    },
    minmax(direction){
      if(direction == "min"){
        return Math.min.apply(Math, this.$store.state.Bets.map(function(o) { return o.Price; }));
      }else if(direction == "max"){
        return Math.max.apply(Math, this.$store.state.Bets.map(function(o) { return o.Price; }));
      }
    },
    oddsSum(){
      let result = 0;
      if(this.$store.state.Bets.length != 0){
        result = this.$store.state.Bets.map(item => item.Price).reduce((a, b) => parseFloat(a) * parseFloat(b))
      }
      if(this.$store.state.Bets.length == 1){
        result = this.$store.state.Bets[0].Price;
        return result
      }
      return result.toFixed(2);
    },
    sum(){
      var sum = (this.$store.state.total / this.$store.state.Bets.length).toString();
      if(sum.indexOf(".") !== -1) sum = sum.slice(0, (sum.indexOf("."))+3);
      sum = Number(sum);
      var reminder = this.$store.state.total - (sum * this.$store.state.Bets.length);
      this.$store.state.Bets.forEach(element => {
        element.Amount = sum;
        if(this.$store.state.Bets[this.$store.state.Bets.length-1] === element){
            element.Amount += reminder;
         }
      })
      return
    },
    error(msg){
      this.state = "Error";
      this.msgs = msg;
      this.show_error = true;
    },
    placeBet(){
      if(this.$store.state.user.Balance == 0) return this.error(this.$t('zerobal'))
      if(this.$store.state.user.Balance < this.$store.state.total) return this.error(this.$t('insufficientbal'))
      if(this.$store.state.Bets == []) return this.error(this.$t('nobets'))
      if(this.$store.state.total == 0) return this.error(this.$t('nomoney'))
      if(this.$store.state.total < this.$store.state.user.Min || this.$store.state.total > this.$store.state.user.Max) return this.error(this.$t('overlimit'))
      if(this.$store.state.user.profit <= -Math.abs(this.$store.state.user.block) && this.$store.state.user.block != 0) return this.error(this.$t('toomuchloss'));

      this.sum();

      this.$store.state.Bets.forEach(element => {
        element.GameID = this.$store.state.game.GameID;
      });

      this.$store.dispatch('apirequestPOST', {name: 'bet/', token: this.$store.state.user.token, data: {type: this.express, Amount: this.$store.state.total, bets: this.$store.state.Bets}}).then((response)=>{
        if(!response){
          alert('Bet sent but no response from server.');
          return;
        }

        if(response.Error){
          return alert(response.Error)
        }

        let date = new Date().toString();
        let code = response.data.TicketCode;

        this.$store.state.Bets[0].GameID = this.$store.state.game.League + ":" + this.$store.state.game.Week;

        this.$store.dispatch('lastprint', {
          teams: this.$store.state.teams,
          ticket: this.$store.state.Bets,
          Code: code,
          date: date,
          type: this.express
        });

        this.$store.dispatch('apirequest', {token: this.$store.state.user.token, name: "users/balance"});
        this.$store.dispatch('apirequest', {token: this.$store.state.user.token, name: "jackpot/"+this.$store.state.user.id});
        let printw = window.open('','targetWindow', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes');/*,width=200,height=400*/
        let component = Vue.extend(ticket);
        let instance = new component({
          propsData: {
            teams: this.$store.state.teams,
            ticket: this.$store.state.Bets,
            Code: code,
            date: date,
            type: this.express
          }
        });
        this.$store.state.Bets = [];
        this.$store.state.total = 0;
        instance.$mount();
        printw.document.body.appendChild(instance.$el);
        printw.print();
        setTimeout(function () { printw.close(); }, 100);
        return response;
      });
    },
    logout(){
      Cookies.remove('username', { path: '' })
      Cookies.remove('password', { path: '' })
      this.$store.state.Bets = [];
      this.$store.state.total = 0;
      this.$store.dispatch('logout');
      this.$router.push({name: 'auth'});
    },
    tv(){
      let routeData = this.$router.resolve({name: 'TV', params: {Token: this.$store.state.user.id, lang: this.$i18n.locale}});
      return window.open(routeData.href, "", "width="+window.screen.width+",height="+window.screen.height);
    },
    rightclick(){
      let routeData = this.$router.resolve({name: 'TV', params: {Token: this.$store.state.user.id, lang: this.$i18n.locale}});
      return window.open(routeData.href);
    },
    payment(name){
      this.state = name;
      this.show_payment = true
    },
    repeat(){
      if(!this.$store.state.lastprint) return
      let printw = window.open('','targetWindow', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes');/*,width=200,height=400*/
        let component = Vue.extend(ticket);
        let instance = new component({
          
          propsData: this.$store.state.lastprint
        });
        instance.$mount();
        printw.document.body.appendChild(instance.$el);
        printw.print();
        setTimeout(function () { printw.close(); }, 100);
        this.$store.state.Bets = [];
        this.$store.state.total = 0;
        return this.$store.state.lastprint
    }
  },
    watch: {
      '$store.state.Bets': function(bets){
        if(bets.length > 1){
          this.statetype = ['express', 'single'];
          this.express = true;
        }else{
          this.statetype = ['single', 'express'];
          this.express = false;
        }
      }
    }
};
/*
  <input type="number" name="Total" :value="num"><br>
*/
</script>
<style>
   
</style>


/*
express
background-color: #96B9B5;


single
background-color: #3A5742;

*/